import { render, staticRenderFns } from "./SelectUom.vue?vue&type=template&id=0d73f4de&"
import script from "./SelectUom.vue?vue&type=script&lang=js&"
export * from "./SelectUom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports